import { Section } from './section.model';
import { HttpParams } from '@angular/common/http';

interface BaseQuestion {
  title: string;
  description?: string;
  questionTypeId: number;
  sectionId: number;
  options: QuestionOption[];
}

export interface QuestionOption {
  id?: number;
  text: string;
}

export interface Question extends BaseQuestion {
  questionId: number;
  isEditable: boolean;
  orderNumber: number;
  required: boolean;
}

export interface QuestionForm {
  title: string;
  description: string;
  questionType: QuestionType | null;
  section: Section | null;
  options: string[];
}

export interface QuestionType {
  id: number;
  name: SupportedQuestionTypes;
  label: string;
  requiresOptions: boolean;
  description: string;
}

export interface QuestionSearchRequest {
  search?: string;
  sectionId?: number;
  typeId?: number;
  paginate?: boolean;
  params?: HttpParams;
}

export interface QuestionCreateRequest {
  title: string;
  description?: string;
  questionTypeId: number;
  sectionId: number;
  options: string[];
  questionId: number;
  isEditable: boolean;
  orderNumber: number;
  required: boolean;
}

export enum SupportedQuestionTypes {
  YES_NO = 'YES/NO',
  NUMERIC = 'NUMERIC',
  SCALE = 'SCALE',
  MULTICHOICE = 'MULTICHOICE',
  TEXT = 'TEXT',
  DATE = 'DATE',
  FREE_TEXT = 'FREE_TEXT',
  // FILE = 'FILE',
  // This is implemented as a select
  // TODO: Refactor as needed.
  DROPDOWN = 'DROPDOWN',
  // RANGE = 'RANGE',

  // TODO: Refactor after radio group is supported in beckend
  // STAR_RATING = 'STAR_RATING',
}
